var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpingBuisnessAutomate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,9.21c-2.2,0-4,1.8-4,4s1.8,4,4,4,4-1.8,4-4-1.8-4-4-4ZM20,18.81c-3.09,0-5.6-2.51-5.6-5.6s2.51-5.6,5.6-5.6,5.6,2.51,5.6,5.6-2.51,5.6-5.6,5.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.4,14.81c-1.32,0-2.4,1.08-2.4,2.4s1.08,2.4,2.4,2.4,2.4-1.08,2.4-2.4-1.08-2.4-2.4-2.4ZM30.4,21.21c-2.2,0-4-1.8-4-4s1.8-4,4-4,4,1.8,4,4-1.8,4-4,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.91,15.61c-1.32,0-2.4,1.08-2.4,2.4s1.08,2.4,2.4,2.4,2.4-1.08,2.4-2.4-1.08-2.4-2.4-2.4ZM8.91,22.01c-2.2,0-4-1.8-4-4s1.79-4,4-4,4,1.8,4,4-1.8,4-4,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.6,32.39c-.44,0-.8-.36-.8-.8,0-4.85-3.95-8.8-8.8-8.8s-8.8,3.95-8.8,8.8c0,.44-.36.8-.8.8s-.8-.36-.8-.8c0-5.73,4.67-10.4,10.4-10.4s10.4,4.67,10.4,10.4c0,.44-.36.8-.8.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.6,31.61c-.44,0-.8-.36-.8-.8,0-3.09-2.51-5.6-5.6-5.6-1.03,0-2.03.28-2.9.81-.38.23-.87.11-1.1-.27-.23-.38-.11-.87.27-1.1,1.12-.68,2.41-1.04,3.73-1.04,3.97,0,7.2,3.23,7.2,7.2,0,.44-.36.8-.8.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.4,31.61c-.44,0-.8-.36-.8-.8,0-3.97,3.23-7.2,7.2-7.2,1.32,0,2.61.36,3.73,1.04.38.23.5.72.27,1.1-.23.38-.72.5-1.1.27-.87-.53-1.87-.81-2.9-.81-3.09,0-5.6,2.51-5.6,5.6,0,.44-.36.8-.8.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpingBuisnessAutomate);
export default __webpack_public_path__ + "static/media/helping-buisness-automate.9cc6ba8cabd203ac84668724decae905.svg";
export { ForwardRef as ReactComponent };